import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import GetToken from "./GetToken";
import toast, { Toaster } from 'react-hot-toast';


/* 
Token is valid for 2 hours but will be refreshed when the user navigates or performs certain actions.
Every component has a token check on page render that will redirect the user if there is no valid token.
When "Remember me" is selected on login, login credentials are stored in browser local storage and will be 
used to login if the user leaves and returns before the token expires.
*/

const TokenLogin = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    //If local storage data is found and is complete
    if (localStorage.getItem("token") != null &&
        localStorage.getItem("id") != null &&
        localStorage.getItem("firstname") != null &&
        localStorage.getItem("lastname") != null &&
        localStorage.getItem("username") != null &&
        localStorage.getItem("email") != null &&
        localStorage.getItem("mustchangepassword") != null &&
        localStorage.getItem("role") != null) {

        //Check if token is good
        CheckToken(localStorage.getItem("id"), localStorage.getItem("token"))
            .then((response) => {
                //If token is valid, apply local data to user context
                if (response) {
                    setUser(
                        {
                            token: localStorage.getItem("token"),
                            id: localStorage.getItem("id"),
                            firstname: localStorage.getItem("firstname"),
                            lastname: localStorage.getItem("lastname"),
                            username: localStorage.getItem("username"),
                            email: localStorage.getItem("email"),
                            mustchangepassword: localStorage.getItem("mustchangepassword"),
                            role: localStorage.getItem("role")
                        }
                    );
                }
                else {
                    localStorage.clear();
                    navigate("/");
                }
            });
    }

    //Triggers when "user" in user context is changed
    useEffect(() => {

        if (user["email"] != undefined) {
            if (user["mustchangepassword"] == "true") {
                navigate("/ChangePassword");
            }
            else {
                navigate("/DesignFolder");
            }

        }

    }, [user])

    const handleEnterKeyPressed = (e) => {
        if (e.keyCode == 13) {
            handleFormSubmit();
        }

    };

    const handleFormSubmit = (e) => {

        let u = document.getElementById("email").value.toLowerCase();
        let p = document.getElementById("password").value;

        //create a new token
        GetToken(u, p)
            .then((data) => {

                if (data != null) {

                    //If box is checked, store login data in local storage
                    if (document.getElementById("rememberme").checked) {
                        localStorage.setItem("token", data.Table[0][0]);
                        localStorage.setItem("id", data.Table[0][1]);
                        localStorage.setItem("firstname", data.Table[0][2]);
                        localStorage.setItem("lastname", data.Table[0][3]);
                        localStorage.setItem("username", data.Table[0][4]);
                        localStorage.setItem("email", data.Table[0][4]);
                        localStorage.setItem("mustchangepassword", data.Table[0][5]);
                        localStorage.setItem("role", data.Table[0][6]);
                    }

                    //apply user data from GetToken request
                    setUser(
                        {
                            token: data.Table[0][0],
                            id: data.Table[0][1],
                            firstname: data.Table[0][2],
                            lastname: data.Table[0][3],
                            username: data.Table[0][4],
                            email: data.Table[0][4],
                            mustchangepassword: data.Table[0][5],
                            role: data.Table[0][6]
                        });
                }
                else {
                    toast.error('Invalid Password');
                }

            });

    };

    document.title = "Login";
    return (

        <div className="TokenLogin">
            {localStorage.getItem("email") == undefined &&
                <>
                    <div className="container body-content" style={{ marginTop: "25px" }}>
                        <div className="container" style={{ marginTop: "25px", display: "flex", flexDirection: "column", alignItems: "center" }}>

                            <form id="loginForm" noValidate="novalidate" autoComplete="off">
                                <h2>Sign In</h2>
                                <div className="form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <input className="form-control" style={{ width: "360px" }} id="email" name="email" placeholder="Email Address" type="text" autoComplete="off" />

                                    <label htmlFor="password">Password</label>
                                    <input className="form-control" style={{ width: "360px" }} id="password" name="password" placeholder="password" type="password" autoComplete="off" onKeyUp={(e) => { handleEnterKeyPressed(e) }} />

                                </div>
                                <div className="form-group" style={{ display: "flex", flexDirection: "row" }}>
                                    <input className="form-check-input" type="checkbox" defaultChecked="checked" id="rememberme" />
                                    <label htmlFor="rememberme">&nbsp;Remember Me</label>

                                </div>
                            </form>

                            <div className="" style={{ display: "flex", flexDirection: "row" }}>
                                <button onClick={handleFormSubmit} className="btn btn-primary" style={{ marginRight: "4px", paddingLeft: "32px", paddingRight: "32px" }}>Login</button>
                            </div>

                        </div>
                    </div>
                </>

            }

        </div>
    );
}

export default TokenLogin;